import React from 'react';
import styled from 'styled-components';
import { Text } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled(Text).attrs({
  styleType: 'small',
  color: colors.smoke,
  uppercase: true,
})``;

const Value = styled(Text).attrs({
  styleType: 'medium',
  color: colors.charcoal,
})`
  display: block;
`;

interface FieldDisplayProps {
  label: string;
  value?: string | number | null;
}

const FieldDisplay: React.FC<FieldDisplayProps> = ({ label, value }) => (
  <FieldContainer>
    <Label>{label}</Label>
    <Value>{value ?? '-'}</Value>
  </FieldContainer>
);

export default FieldDisplay;
